import "assets/css/styles.css?v=1.9.0";

import * as Sentry from "@sentry/browser";

import { Route, Router } from "react-router-dom";

import { CaptureConsole } from "@sentry/integrations";
import DateFnsUtils from "@date-io/date-fns";
import { Integrations } from "@sentry/tracing";
import MainRouter from "views/mainrouter";
import { MuiPickersUtilsProvider } from "@material-ui/pickers";
import { Provider } from "react-redux";
import React from "react";
import { clearCookiesAndLocalStorage } from "utils/clearCookies";
import configureStore from "./config/configureStore";
import { createBrowserHistory } from "history";
import { createRoot } from "react-dom/client";
import { get } from "lodash";
import { syncORMWithStore } from "./orm";

const isDev = process.env.NODE_ENV === "development";

if (get(window, ["LOCAL_SETTINGS", "SENTRY_DSN"])) {
  Sentry.init({
    dsn: window.LOCAL_SETTINGS.SENTRY_DSN,
    release: "bossfotos_photographer",
    environment: isDev ? "development" : "production",
    integrations: [
      new Integrations.BrowserTracing(),
      new CaptureConsole({
        levels: ["error"],
      }),
    ],
    tracesSampleRate: 1.0,
    ignoreErrors: [
      "Warning: Failed prop type",
      "Warning: React does not",
      "prop to a form field without an",
      "validateDOMNesting",
      "Each child in a list should have a unique ",
      "for a non-boolean attribute ",
      "Warning: Unknown event handler property",
      "Warning: Failed %s type: %s%s prop Invalid prop",
      "should not be null. Consider using an",
      "Warning: Cannot update a component",
      "Warning: Invalid DOM property",
      "Warning: A component is changing an uncontrolled input to be controlled",
    ],
  });
}

clearCookiesAndLocalStorage();
const hist = createBrowserHistory();
export const store = configureStore();
syncORMWithStore(store);

const root = createRoot(document.getElementById("root"));

root.render(
  <Provider store={store}>
    <MuiPickersUtilsProvider utils={DateFnsUtils}>
      <Router history={hist}>
        <Route path="/" component={MainRouter} />
      </Router>
    </MuiPickersUtilsProvider>
  </Provider>,
);
